export class RecyclingBacStoreDetail {
  constructor(
    technicalId,
    boomerangId,
    designation,
    fillingThreshold,
    currentCount,
    recyclerName,
    recyclerLogoName,
    recyclerLogoUrl
  ) {
    this.technicalId = technicalId
    this.boomerangId = boomerangId
    this.designation = designation
    this.fillingThreshold = fillingThreshold
    this.currentCount = currentCount
    this.recyclerName = recyclerName
    this.recyclerLogoName = recyclerLogoName
    this.recyclerLogoUrl = recyclerLogoUrl
  }
}
